import types from '@/vuex/arquivos-documento/actions-types'
import documentos from '@/utils/documentos'
import dates from '@/utils/dates'

const CINCO_MEBIBYTES = 5242880
const TEXTO_SUGESTAO_OTIMIZADOR_PDF = '\nFavor consultar link ao lado do botão "Adicionar Arquivos" para maiores informações.'

const actions = {
  [types.GET_LISTA_MOTIVOS_RESTRICOES_ARQUIVO]: async ({ commit }) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando upload de arquivo' }, {root: true})
    try {
      const response = await documentos.getMotivosRestricoesArquivo()
      commit(types.SET_LISTA_MOTIVOS_RESTRICOES_ARQUIVO, { listaMotivosRestricoesArquivo: response.data })
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar a lista de motivos de restrições de arquivos' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando upload de arquivo' }, {root: true})
    }
  },
  [types.GET_LISTA_PECAS]: async ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando peças' }, {root: true})
    try {
      const response = await documentos.getListaPecas(payload.documento.idDocumento)
      let items = response.data

      let documentoPertenceAoUsuario = payload.usuario &&
        (payload.presenteCaixaPostal || payload.raizPresenteCaixaPostal) &&
        (payload.documento.situacao === 'RECEBIDO' || payload.documento.situacao === 'EM_CRIACAO')

      let usuarioLogadoEhOInteressado = payload.usuario && payload.documento && (payload.documento.idPessoaInteressado === payload.usuario.idPessoa)

      for (let item of items) {
        item.dias = dates.daysDiff(item.dataDespacho, item.dataRecebimento)
        if (item.situacaoVinculo === 'M') {
          item.restrito = !(payload.usuario && payload.usuario.permissoes.includes('VISUALIZACAO_IRRESTRITA_PECAS'))
          item.tipoArquivo = item.descricao = item.passoFluxo = payload.usuario && payload.usuario.permissoes.includes('VISUALIZACAO_IRRESTRITA_PECAS') ? item.passoFluxo.concat(' (DESMEMBRADA)') : 'DESMEMBRADA'
        } else if (item.situacaoVinculo === 'D') {
          item.restrito = !(payload.usuario && payload.usuario.permissoes.includes('VISUALIZACAO_IRRESTRITA_PECAS'))
          item.tipoArquivo = item.descricao = item.passoFluxo = payload.usuario && payload.usuario.permissoes.includes('VISUALIZACAO_IRRESTRITA_PECAS') ? item.passoFluxo.concat(' (DESENTRANHADA)') : 'DESENTRANHADA'
        } else if (item.nivelAcesso === 'R' &&
                   !documentoPertenceAoUsuario &&
                   !(usuarioLogadoEhOInteressado && (item.sequenciaTramitacao === 1 || payload.documento.estado[2001] === 2 || payload.documento.estado[2001] === 3))) {
          item.restrito = !(payload.usuario && payload.usuario.permissoes.includes('VISUALIZACAO_IRRESTRITA_PECAS'))
          item.tipoArquivo = item.descricao = item.passoFluxo = payload.usuario && payload.usuario.permissoes.includes('VISUALIZACAO_IRRESTRITA_PECAS') ? item.passoFluxo.concat(' (RESTRITO)') : 'RESTRITO - Motivo: ' + item.descricaoHipoteseLegal
        } else {
          item.restrito = false
          if (item.idAnexo) {
            const formato = item.nome.split('.').pop()
            if (formato === 'jpg') item.tipoArquivo = 'Imagem JPG'
            if (formato === 'png') item.tipoArquivo = 'Imagem PNG'
            if (formato === 'bmp') item.tipoArquivo = 'Imagem BMP'
            if (formato === 'gif') item.tipoArquivo = 'Imagem GIF'
            if (formato === 'mp3') item.tipoArquivo = 'Áudio MP3'
            if (formato === 'mp4') item.tipoArquivo = 'Vídeo MP4'
            if (formato === 'pdf') item.tipoArquivo = 'Documento PDF'
            if (formato === 'zip') item.tipoArquivo = 'Arquivo compactado ZIP'
          } else {
            item.tipoArquivo = 'Despacho'
          }
        }
      }
      commit(types.SET_LISTA_PECAS, { listaPecas: items })
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar as peças do documento' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando peças' }, {root: true})
    }
  },
  [types.SET_LISTA_ARQUIVOS]: ({ commit }, payload) => {
    commit(types.SET_LISTA_ARQUIVOS, payload)
  },
  [types.GET_ARQUIVO]: async ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando arquivo' }, {root: true})
    try {
      const response = await documentos.getArquivo(payload.idDocumento, payload.idArquivo)
      commit(types.SET_ARQUIVO, { arquivo: response.data })
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível buscar o arquivo' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando arquivo' }, {root: true})
    }
  },
  [types.SET_ARQUIVO]: ({ commit }, payload) => {
    commit(types.SET_ARQUIVO, payload)
  },
  [types.SET_SITUACAO_VINCULO]: ({ commit }, payload) => {
    commit(types.SET_SITUACAO_VINCULO, payload)
  },
  [types.SET_PASSO_ATUAL]: ({ commit }, payload) => {
    commit(types.SET_PASSO_ATUAL, payload)
  },
  [types.GET_ARQUIVO_BLOB_URL]: async ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando arquivo' }, {root: true})
    commit(types.SET_ARQUIVO_BLOB_URL, {arquivoBlobURL: null})
    try {
      const response = await documentos.getArquivoBinario(payload.idDocumento, payload.arquivo.idAcessoAnexo)
      let type = ''
      // Quando for despacho, que não tem nome, já é do tipo PDF
      if (payload.arquivo.nome === null) {
        payload.arquivo.nome = 'despacho.pdf'
        type = 'application/pdf'
      } else {
        const formato = payload.arquivo.nome.split('.').pop()
        if (formato === 'jpg') type = 'image/jpg'
        else if (formato === 'png') type = 'image/png'
        else if (formato === 'bmp') type = 'image/bmp'
        else if (formato === 'gif') type = 'image/gif'
        else if (formato === 'mp3') type = 'audio/mp3'
        else if (formato === 'mp4') type = 'video/mp4'
        else if (formato === 'pdf') type = 'application/pdf'
      }
      const blob = new Blob([response.body], {type: type})
      const blobURL = (window.URL || window.webkitURL).createObjectURL(blob)
      commit(types.SET_ARQUIVO_BLOB_URL, {arquivoBlobURL: blobURL})
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível abrir o arquivo' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Abrindo arquivo' }, {root: true})
    }
  },
  [types.VALIDAR_RESTRICOES_ARQUIVO]: async ({ commit }, payload) => {
    if (!payload.arquivo.tipoCopia || !payload.arquivo.nivelAcesso || (payload.arquivo.nivelAcesso && payload.arquivo.nivelAcesso.id === 'R' && !payload.arquivo.motivoRestricao)) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: `Há campos não definidos para o arquivo "${payload.arquivo.nome}"` }, {root: true})
      return false
    }
    return true
  },
  [types.VALIDAR_TAMANHO_ARQUIVO]: async ({ commit }, payload) => {
    if (payload.documento !== null) {
      if (payload.documento.estado['32005'] === 2) { // Estado em que é permitido anexar até 50MiB
        if (payload.arquivo.size > CINCO_MEBIBYTES * 10) { // 50 MiB
          commit(types.SHOW_SNACKBAR, {
            snackbarType: 'error',
            snackbarText: 'Arquivos maiores que 50 MebiBytes (aproximadamente 50,42 MegaBytes) não podem ser adicionados a documentos nesta fase.' +
                TEXTO_SUGESTAO_OTIMIZADOR_PDF
          }, { root: true })
          return false
        }
      } else {
        if (payload.arquivo.size > CINCO_MEBIBYTES) { // 5 MiB
          commit(types.SHOW_SNACKBAR, {
            snackbarType: 'error',
            snackbarText: 'Arquivos maiores que 5 MebiBytes (aproximadamente 5,24 MegaBytes) não podem ser adicionados a documentos nesta fase.' +
                TEXTO_SUGESTAO_OTIMIZADOR_PDF
          }, {root: true})
          return false
        }
      }
    } else {
      if (payload.arquivo.size > CINCO_MEBIBYTES * 10) { // 50 MiB
        commit(types.SHOW_SNACKBAR, {
          snackbarType: 'error',
          snackbarText: 'Arquivos maiores que 50 MebiBytes (aproximadamente 50,42 MegaBytes) não podem ser adicionados para serem assinados.' +
              TEXTO_SUGESTAO_OTIMIZADOR_PDF
        }, {root: true})
        return false
      }
    }
    return true
  },
  [types.ENVIAR_ARQUIVO]: async ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: `Enviando ${payload.body.get('arquivo').name}` }, {root: true})
    try {
      await documentos.enviarArquivo(payload.idDocumento, payload.body)
      commit(types.SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: `Arquivo ${payload.body.get('arquivo').name} enviado com sucesso` }, {root: true})
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: `Arquivo ${payload.body.get('arquivo').name} não enviado: ${error.body.message}` }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: `Enviando ${payload.body.get('arquivo').name}` }, {root: true})
    }
  },
  [types.ENVIAR_ARQUIVO_ASSINADO]: async ({ commit }, payload) => {
    let nomeArquivo = payload.body.get('arquivo').name
    if (nomeArquivo === undefined) nomeArquivo = payload.body.get('arquivo')
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: `Enviando ${nomeArquivo}` }, {root: true})
    try {
      await documentos.enviarArquivoAssinado(payload.idArquivoAssinado, payload.idDocumento, payload.body)
      commit(types.SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: `Arquivo ${nomeArquivo} enviado com sucesso` }, {root: true})
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: `Arquivo ${nomeArquivo} não enviado: ${error.body.message}` }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: `Enviando ${nomeArquivo}` }, {root: true})
    }
  },

  [types.SALVAR_EDICAO_ARQUIVO]: async ({ commit }, payload) => {
    let textoNomeArquivo = payload.arquivoSelecionado.nome ? payload.arquivoSelecionado.nome : 'Despacho - Sequencial ' + payload.arquivoSelecionado.sequencial
    const confirmacaoCallback = async () => {
      try {
        commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Salvando alterações em ' + textoNomeArquivo }, {root: true})
        await documentos.salvarAlteracoesArquivo(
            payload.idDocumento,
            payload.arquivoSelecionado.idAcessoAnexo,
            payload.arquivoSelecionado.idAnexo,
            payload.arquivoEditado)
        let item = payload.arquivoSelecionado
        Object.assign(item, {
          tipoCopia: payload.arquivoEditado.tipoCopia,
          nivelAcesso: payload.arquivoEditado.nivelAcesso,
          idHipoteseLegal: payload.arquivoEditado.idHipoteseLegal,
          descricao: payload.arquivoEditado.descricao
        })
        commit(types.ALTERAR_PECA_LISTA, { arquivoSelecionadoIndex: payload.arquivoSelecionadoIndex, arquivo: item })
        commit(types.HIDE_EDICAO_ARQUIVO_DIALOG)
        commit(types.SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Arquivo ' + textoNomeArquivo + ' alterado com sucesso' }, {root: true})
      } catch (error) {
        commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível alterar o arquivo ' + textoNomeArquivo }, {root: true})
        throw error
      } finally {
        commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Salvando alterações em ' + textoNomeArquivo }, {root: true})
      }
    }

    const config = {
      textoPergunta: 'Alterar o arquivo?',
      textoConteudo: textoNomeArquivo + ' será alterado conforme especificado.',
      textoNao: 'Cancelar',
      textoSim: 'Alterar',
      confirmacaoCallback: confirmacaoCallback
    }
    commit(types.SHOW_CONFIRMATION_DIALOG, { ...config }, {root: true})
  },

  [types.EXCLUIR_ARQUIVO]: ({ commit }, payload) => {
    const confirmacaoCallback = async () => {
      try {
        commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: `Excluindo arquivo ${payload.arquivoSelecionado.nome}` }, {root: true})
        await documentos.excluirArquivo(payload.idDocumento, payload.arquivoSelecionado.idAnexo)
        commit(types.REMOVER_ARQUIVO_LISTA, { arquivoSelecionadoIndex: payload.arquivoSelecionadoIndex, arquivoSelecionado: payload.arquivoSelecionado })
        commit(types.SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: `"${payload.arquivoSelecionado.nome}" excluído com sucesso` }, {root: true})
      } catch (error) {
        commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: `Não foi possível excluir "${payload.arquivoSelecionado.nome}"` }, {root: true})
        throw error
      } finally {
        commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: `Excluindo arquivo ${payload.arquivoSelecionado.nome}` }, {root: true})
      }
    }
    const config = {
      textoPergunta: 'Excluir o arquivo?',
      textoConteudo: `O arquivo "${payload.arquivoSelecionado.nome}" será excluída deste documento permanentemente.`,
      textoNao: 'Cancelar',
      textoSim: 'Excluir',
      confirmacaoCallback: confirmacaoCallback
    }
    commit(types.SHOW_CONFIRMATION_DIALOG, { ...config }, {root: true})
  },

  [types.CANCELAR_PECA]: ({ commit }, payload) => {
    const confirmacaoCallback = async () => {
      try {
        commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: `Cancelando ${payload.arquivoSelecionado.nome ? ' arquivo: ' + payload.arquivoSelecionado.nome : 'despacho'}` }, {root: true})
        await documentos.cancelarPeca(payload.idDocumento, payload.arquivoSelecionado.idAcessoAnexo, payload.situacaoVinculo.tipo, payload.justificativaCancelamento, payload.documentoSelecionado.idDocumento)
        let item = payload.arquivoSelecionado
        Object.assign(item, {
          situacaoVinculo: payload.situacaoVinculo.tipo,
          justificativaCancelamento: payload.justificativaCancelamento,
          tipoArquivo: payload.situacaoVinculo.tipo === 'M' ? 'DESMEMBRADA' : 'DESENTRANHADA',
          descricao: payload.situacaoVinculo.tipo === 'M' ? 'DESMEMBRADA' : 'DESENTRANHADA',
          passoFluxo: payload.situacaoVinculo.tipo === 'M' ? 'DESMEMBRADA' : 'DESENTRANHADA'
        })
        commit(types.ALTERAR_PECA_LISTA, { arquivoSelecionadoIndex: payload.arquivoSelecionadoIndex, arquivo: item })
        commit(types.HIDE_EXCLUSAO_ARQUIVO_DIALOG)
        commit(types.SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: `${payload.arquivoSelecionado.nome ? ' arquivo: ' + payload.arquivoSelecionado.nome : 'despacho'} cancelado com sucesso` }, {root: true})
      } catch (error) {
        commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: `Não foi possível cancelar o ${payload.arquivoSelecionado.nome ? ' arquivo: ' + payload.arquivoSelecionado.nome : 'despacho'}` }, {root: true})
        throw error
      } finally {
        commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: `Cancelando ${payload.arquivoSelecionado.nome ? ' arquivo: ' + payload.arquivoSelecionado.nome : 'despacho'}` }, {root: true})
      }
    }
    const config = {
      textoPergunta: `${payload.situacaoVinculo.tipo === 'M' ? 'Desmembrar' : 'Desentranhar'} a peça?`,
      textoConteudo: `A peça "${payload.arquivoSelecionado.nome}" será ${payload.situacaoVinculo.tipo === 'M' ? 'desmembrada' : 'desentranhada'} permanentemente.`,
      textoNao: 'Cancelar',
      textoSim: `${payload.situacaoVinculo.tipo === 'M' ? 'Desmembrar' : 'Desentranhar'}`,
      confirmacaoCallback: confirmacaoCallback
    }
    commit(types.SHOW_CONFIRMATION_DIALOG, { ...config }, {root: true})
  },

  [types.GET_LISTA_DOCUMENTOS]: async ({ commit }, payload) => {
    try {
      commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando documentos' }, {root: true})
      commit(types.SET_DOCUMENTO_SELECIONADO, { documentoSelecionado: {} })
      commit(types.SET_LISTA_DOCUMENTOS, { listaDocumentos: [] })
      const response = await documentos.getListaDocumentosParaJuntada(payload.numeroDocumento)
      let listaDocumentos = response.data.filter((documento) => {
        return (
          documento.idDestino === payload.idUnidadeAtual &&
          documento.estado['2001'] === 1 &&
          documento.dataValidade !== null &&
          documento.situacao !== 'E')
      })
      if (listaDocumentos.length === 0) {
        commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Nenhum documento encontrado. Documentos que não constam em sua caixa postal, de setores diferentes, arquivados, não recebidos ou ainda em criação não podem ter suas peças alteradas' }, {root: true})
      } else {
        commit(types.SET_LISTA_DOCUMENTOS, { listaDocumentos: listaDocumentos })
      }
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar documentos' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando documentos' }, {root: true})
    }
  },

  [types.GET_LISTA_ARQUIVOS_ASSINADOS_NAO_VINCULADOS]: async ({ commit }, payload) => {
    try {
      commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando Arquivos Assinados' }, {root: true})
      const response = await documentos.buscarArquivosAssinadosVinculados(
          payload.vinculados,
          payload.usuarioAssinante,
          payload.dataAssinaturaInicio,
          payload.dataAssinaturaFim,
          payload.arquivosAssinadosUsuario)
      commit(types.SET_LISTA_ARQUIVOS_ASSINADOS_NAO_VINCULADOS, { listaArquivosAssinadosNaoVinculados: response.data })
      if (response.data.length === 50) {
        commit(types.SHOW_SNACKBAR, { snackbarType: 'warning', snackbarText: 'Limite de busca de 50 arquivos atingido. Favor filtrar melhor a busca caso o arquivo buscado não estiver nos resultados' }, {root: true})
      }
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível buscar os arquivos assinados' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando Arquivos Assinados' }, {root: true})
    }
  },

  [types.SET_LISTA_DOCUMENTOS]: async ({ commit }, payload) => {
    commit(types.SET_LISTA_DOCUMENTOS, payload)
  },
  [types.SET_DOCUMENTO_SELECIONADO]: async ({ commit }, payload) => {
    commit(types.SET_DOCUMENTO_SELECIONADO, payload)
  },
  [types.SET_JUSTIFICATIVA_CANCELAMENTO]: async ({ commit }, payload) => {
    commit(types.SET_JUSTIFICATIVA_CANCELAMENTO, payload)
  },
  [types.SET_LISTA_ARQUIVOS_ASSINADOS_NAO_VINCULADOS]: async ({ commit }, payload) => {
    commit(types.SET_LISTA_ARQUIVOS_ASSINADOS_NAO_VINCULADOS, payload)
  },
  [types.SHOW_EDICAO_ARQUIVO_DIALOG]: async ({ commit }) => {
    commit(types.SHOW_EDICAO_ARQUIVO_DIALOG)
  },
  [types.HIDE_EDICAO_ARQUIVO_DIALOG]: async ({ commit }) => {
    commit(types.HIDE_EDICAO_ARQUIVO_DIALOG)
  },
  [types.SHOW_CANCELAMENTO_PECA_DIALOG]: async ({ commit }) => {
    commit(types.SHOW_CANCELAMENTO_PECA_DIALOG)
  },
  [types.HIDE_EXCLUSAO_ARQUIVO_DIALOG]: async ({ commit }) => {
    commit(types.HIDE_EXCLUSAO_ARQUIVO_DIALOG)
  },
  [types.SHOW_ADICIONAR_ARQUIVO_ASSINADO_DIALOG]: async ({ commit }) => {
    commit(types.SHOW_ADICIONAR_ARQUIVO_ASSINADO_DIALOG)
  },
  [types.HIDE_ADICIONAR_ARQUIVO_ASSINADO_DIALOG]: async ({ commit }) => {
    commit(types.HIDE_ADICIONAR_ARQUIVO_ASSINADO_DIALOG)
  },
  [types.SHOW_INFORMACOES_PECAS_UPLOAD_DIALOG]: async ({ commit }) => {
    commit(types.SHOW_INFORMACOES_PECAS_UPLOAD_DIALOG)
  },
  [types.HIDE_INFORMACOES_PECAS_UPLOAD_DIALOG]: async ({ commit }) => {
    commit(types.HIDE_INFORMACOES_PECAS_UPLOAD_DIALOG)
  },
  [types.ATUALIZAR_SEQUENCIAL_PECA]: async ({ commit }, payload) => {
    try {
      commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Atualizando Sequencial' }, {root: true})
      let pecas = payload.pecas
      let maiorSequencial = Math.max.apply(Math, pecas.filter(p => p.situacaoTramitacao === 'T').map(function (o) { return o.sequencial }))
      let menorSequencial = Math.min.apply(Math, pecas.filter(p => p.situacaoTramitacao === 'T').map(function (o) { return o.sequencial }))

      let novoSequencial = payload.novoSequencial
      let sequencialAntigo = payload.sequencialAntigo

      novoSequencial = novoSequencial > maiorSequencial ? maiorSequencial : (novoSequencial < menorSequencial ? menorSequencial : novoSequencial)
      let idPeca = pecas.filter(p => p.sequencial === sequencialAntigo).map(p => { return p.idAcessoAnexo })

      await documentos.alterarSequencialPeca(payload.idDocumento, idPeca, novoSequencial)

      commit(types.ALTERAR_SEQUENCIAL, {sequencialAntigo: sequencialAntigo, novoSequencial: novoSequencial})
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: error.body.message }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Atualizando Sequencial' }, {root: true})
    }
  }
}

export default actions
